import React, { PureComponent } from 'react';
import injectSheet from 'react-jss'
import cn from 'classnames'
import ResponsiveImage from '../Widgets/ResponsiveImage'
import Link, {UnstyledLink} from '../Widgets/Link'
import AuthorAndShareLinks from '../Article/AuthorAndShareLinks'
import Summary from "../Widgets/Summary"
import {formatSummary} from "../../utils/search"
import widthHover from '../../hoc/withHover'
import flow from 'lodash/flow'

class SearchResultItem extends PureComponent {

    _getSummary = () => {
        const {query, loading, totalResults} = this.props;
        return formatSummary(query, loading, totalResults);
    }

    render() {
        const {classes, trending, item, onMouseEnter, onMouseLeave, hover} = this.props;

        return <div className={cn( classes.result, 'normalVerticalFlow' )}>
            <ResponsiveImage key={item.slug} images={{desktop: item.images}} className={classes.image}
                             link={item.link}
                             parralax={false} aspect="0.73"
                             onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
            </ResponsiveImage>
            <div className={classes.articleDetails}>
                <UnstyledLink link={item.link} className={classes.link}
                              onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
                    <h3 className={classes.articleTitle}>{item.title}</h3>
                </UnstyledLink>
                <AuthorAndShareLinks article={item} author={item.author} trending={trending} showShareIcons={false} size="small"/>
                {item.summary && <Summary summary={item.summary} clamp={2} className={classes.summary} />}
                <Link link={item.link} hover={hover}>{item.call_to_action_label}</Link>
            </div>
        </div>
    }
}

export default flow([
    widthHover,
    injectSheet((theme) => ({
        result: {
            display: "block",
            marginLeft: '-10px',
            marginRight: '-10px',
            alignItems: 'flex-start',
            '@media (min-width: 560px)': {
                display: "flex",
            }
        },
        image: {
            width: 'auto',
            margin: '0 10px 10px',
            flexShrink: 0,
            '@media (min-width: 560px)': {
                margin: '0 10px',
                width: 300,
            },
            [theme.breakpoint('tablet')]: {
                width: 300,
            },
        },
        articleDetails: {
            flexGrow: 1,
            margin: '0 10px',
            "& > *": {
                marginBottom: 10
            }
        },
        link: {
            textDecoration: 'none'
        },
        articleTitle: {
            fontSize: 16,
            lineHeight: '1.5em',
            marginBottom: 10,
            fontStyle: 'normal',
            [theme.breakpoint('mobile')]: {

            },
            [theme.breakpoint('tablet')]: {
                fontSize: 22,
            }
        },
        summary: {
            "& p": {
                marginBottom: 0
            }
        }
    }))]) (SearchResultItem);



// WEBPACK FOOTER //
// ./src/components/Search/SearchResultItem.js